/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'company-hub.card-extensions.card-config.background-color-field.title': 'Color de fondo',
  'company-hub.card-extensions.card-config.text-color-field.title': 'Color del texto',
  'company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder': 'Ponle un título a tu tarjeta',
  'company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder': 'Ponle un título a tu tarjeta',
  'company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder':
    'Ponle un título a tu tarjeta',
  'company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder':
    'Ponle un título a tu tarjeta',
  'company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder': 'Ponle un título a tu tarjeta',
  'company-hub.cards-extension.ai-disclaimer.disclaimer-message': 'Contenido generado por IA',
  'company-hub.cards-extension.autoscroll-wrapper.pause': 'Pausar',
  'company-hub.cards-extension.autoscroll-wrapper.play': 'Reproducir',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.icon-toggle-label': 'Icono',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.social-stats-toggle-label':
    'Estadísticas sociales',
  'company-hub.cards-extension.card.background.color': 'Color de fondo',
  'company-hub.cards-extension.card.color-contrast.fail':
    'Los colores del texto y del fondo que has elegido no van bien para facilitar la lectura.',
  'company-hub.cards-extension.card.color-contrast.success':
    'Los colores del texto y del fondo que has elegido van bien para facilitar la lectura.',
  'company-hub.cards-extension.card.text.color': 'Color del texto',
  'company-hub.cards-extension.cards.config-panel.border.color': 'Color del borde',
  'company-hub.cards-extension.cards.hub-element.description': 'Presenta enlaces, imágenes y más',
  'company-hub.cards-extension.cards.hub-element.title': 'Tarjetas',
  'company-hub.cards-extension.config-panel.link.field.label': 'Enlace',
  'company-hub.cards-extension.config-panel.render-variant.dynamic': '<p>Dinámicas</p>',
  'company-hub.cards-extension.config-panel.render-variant.dynamic.description':
    'Utiliza las tarjetas <strong>Dinámicas</strong> para crear filtros que generen al instante un conjunto de tarjetas que se actualice automáticamente.',
  'company-hub.cards-extension.config-panel.render-variant.manual': '<p>Manuales</p>',
  'company-hub.cards-extension.config-panel.render-variant.manual.description':
    'Usa las tarjetas <strong>Manuales</strong> para añadir texto, imágenes o enlaces específicos a tu hub.',
  'company-hub.cards-extension.description.field.label': 'Descripción',
  'company-hub.cards-extension.dynamic-card-empty-state.no-filter-title': 'Añade filtros para rellenar las tarjetas.',
  'company-hub.cards-extension.dynamic-card-empty-state.no-results-title': 'Aún no hay nada. Vuelve pronto.',
  'company-hub.cards-extension.link-cards-config-panel.cards.content.display-options.title':
    'Opciones de visualización',
  'company-hub.cards-extension.link-cards-config-panel.cards.error.invalid-list': 'Añade tarjetas',
  'company-hub.cards-extension.link-cards-config-panel.cards.style.general.title': 'General',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.description':
    'El tamaño de la imagen es el mismo en todas las tarjetas',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.label':
    'Altura de imagen fija',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.description':
    'El tamaño de la imagen se adapta a la cantidad de texto',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.label':
    'Altura de imagen flexible',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.title': 'Diseños',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description':
    'Presenta enlaces, imágenes y mucho más. {link}',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description-without-support-link':
    'Presenta enlaces, imágenes y mucho más.',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description.link':
    'Más información acerca de las tarjetas.',
  'company-hub.cards-extension.link-cards-config-panel.content-tab.label': 'Contenido',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.large.label': 'Grande',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.medium.label': 'Mediano',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.small.label': 'Pequeño',
  'company-hub.cards-extension.link-cards-config-panel.size-text-label': 'Tamaño',
  'company-hub.cards-extension.link-cards-config-panel.styles-tab.label': 'Estilos',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-label': 'Desplazamiento automático',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-tooltip-content':
    'Las tarjetas que no quepan en la pantalla empezarán a desplazarse cuando salgas del modo de edición',
  'company-hub.cards-extension.link-cards-config-panel.styles.display-as-label': 'Mostrar como',
  'company-hub.cards-extension.link-cards-config-panel.styles.padding-label': 'Relleno',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-description': 'Las cartas se desplazan en una fila',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-label': 'Fila',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-description':
    'Las tarjetas se ajustan en líneas nuevas',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-label': 'Apilado',
  'company-hub.cards-extension.link-cards-config-panel.title-text-label': 'Tarjetas',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.ai-description.label-v2': 'Descripción',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label': 'Mostrar propietario',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label-v2': 'Propietario del contenido',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.info-icon-label':
    'Elige qué grupos de usuario de Confluence van a ver tu tarjeta.',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.label.label-v2': 'Etiqueta',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label': 'Novedad',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label-v2': 'Novedad',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label':
    'Mostrar última actualización',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label-v2': 'Última actualización',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label':
    'Seleccionar el público objetivo',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label-v2': 'Público objetivo',
  'company-hub.cards-extension.link-cards-content.card-components.build-dynamic-cards': 'Crear tarjetas dinámicas',
  'company-hub.cards-extension.link-cards-content.card-components.card-count-label': 'Número de tarjetas',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button':
    'Cancelar',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button':
    'Borrar todos los filtros',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button':
    'Confirmar',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header':
    'Crear tarjetas dinámicas',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext':
    'Crea un conjunto personalizado de tarjetas que se rellenen automáticamente y muestren la información más reciente. Utiliza filtros para seleccionar el contenido de las tarjetas por etiqueta, espacio, propietario y mucho más.',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-dynamic-cards.header':
    'Ninguna tarjeta dinámica aún',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.description':
    'El contenido no existe o puede haber cambiado después de añadir este enlace',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.header':
    'No podemos mostrarte este contenido',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.button.label':
    'Solicitar acceso',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.description':
    'Deberás solicitar el acceso o probar con otra cuenta para obtener esta vista previa',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.header':
    'Contenido restringido',
  'company-hub.cards-extension.link-cards-content.card-components.view-current-filters': 'Ver filtros actuales',
  'company-hub.cards-extension.manifest.macro-description': 'Mostrar enlaces como tarjetas',
  'company-hub.cards-extension.manifest.macro-title': 'Tarjetas',
  'company-hub.cards-extension.recommended.field.label': '(Recomendado)',
  'company-hub.cards-extension.row-orientation.next': 'Siguiente',
  'company-hub.cards-extension.row-orientation.previous': 'Anterior',
  'company-hub.cards-extension.smart-card.empty-state.placeholder-title': 'Añadir un título',
  'company-hub.cards-extension.smart-card.no-results-title': 'Aún no hay nada aquí. Vuelve pronto.',
  'company-hub.cards-extension.title.field.label': 'Título',
};
